import r from "../managers/braze-instance.js";
import { logger as E } from "../../shared-lib/index.js";
export function destroy() {
  E.info("Destroying Braze instance"), r.destroy(!0);
}
